import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "./Modal";

// Bandeirinhas simples em SVG (em vez de emoji, pra ficar consistente em
// qualquer SO/navegador -- emoji de bandeira quebra em algumas versoes do
// Windows e vira sigla de pais, o que era exatamente o efeito "pouco
// profissional" que a troca de PT/EN/ES por bandeira deveria resolver).
function BandeiraBR() {
  return (
    <svg width="20" height="14" viewBox="0 0 20 14" style={{ display: "block", borderRadius: 2 }}>
      <rect width="20" height="14" fill="#009c3b" />
      <polygon points="10,2 18,7 10,12 2,7" fill="#ffdf00" />
      <circle cx="10" cy="7" r="3.1" fill="#002776" />
    </svg>
  );
}

function BandeiraUS() {
  return (
    <svg width="20" height="14" viewBox="0 0 20 14" style={{ display: "block", borderRadius: 2 }}>
      <rect width="20" height="14" fill="#fff" />
      {[0, 1, 2, 3, 4, 5, 6].map((i) => (
        <rect key={i} y={i * 2} width="20" height="1" fill="#b22234" />
      ))}
      <rect width="9" height="7.5" fill="#3c3b6e" />
    </svg>
  );
}

function BandeiraES() {
  return (
    <svg width="20" height="14" viewBox="0 0 20 14" style={{ display: "block", borderRadius: 2 }}>
      <rect width="20" height="14" fill="#aa151b" />
      <rect y="3.5" width="20" height="7" fill="#f1bf00" />
    </svg>
  );
}

const IDIOMAS = [
  { codigo: "pt", Bandeira: BandeiraBR, chaveNome: "common.idioma_nome_pt" },
  { codigo: "en", Bandeira: BandeiraUS, chaveNome: "common.idioma_nome_en" },
  { codigo: "es", Bandeira: BandeiraES, chaveNome: "common.idioma_nome_es" },
];

// Seletor de idioma (bandeiras PT/EN/ES) usado na landing page, no login e
// no painel logado (via Header.js). A escolha fica salva no localStorage
// (chave "saasgl_idioma", ver frontend/src/i18n/index.js) e persiste entre
// visitas. Troca sempre passa por uma confirmacao (modal proprio, nao
// window.confirm nativo) antes de aplicar.
export default function LanguageSwitcher({ dark = true, style }) {
  const { t, i18n } = useTranslation();
  const atual = (i18n.resolvedLanguage || i18n.language || "pt").slice(0, 2);
  const [pendente, setPendente] = useState(null); // codigo do idioma aguardando confirmacao

  const confirmarTroca = () => {
    if (pendente) i18n.changeLanguage(pendente);
    setPendente(null);
  };

  const idiomaPendente = IDIOMAS.find((i) => i.codigo === pendente);

  return (
    <>
      <div
        style={{
          display: "flex",
          gap: 4,
          background: dark ? "rgba(255,255,255,0.04)" : "var(--bg2, #f1f5f9)",
          border: dark ? "1px solid rgba(255,255,255,0.14)" : "1px solid var(--border, #e2e8f0)",
          borderRadius: 8,
          padding: 3,
          ...style,
        }}
      >
        {IDIOMAS.map((idm) => {
          const ativo = idm.codigo === atual;
          const Bandeira = idm.Bandeira;
          return (
            <button
              key={idm.codigo}
              onClick={() => (ativo ? null : setPendente(idm.codigo))}
              aria-pressed={ativo}
              aria-label={t(idm.chaveNome)}
              title={t(idm.chaveNome)}
              style={{
                border: "none",
                borderRadius: 6,
                padding: "5px 7px",
                display: "flex",
                alignItems: "center",
                cursor: ativo ? "default" : "pointer",
                background: ativo ? (dark ? "#3b82f6" : "#2563eb") : "transparent",
                opacity: ativo ? 1 : 0.75,
                transition: "all .15s",
              }}
            >
              <Bandeira />
            </button>
          );
        })}
      </div>

      {pendente && (
        <Modal onClose={() => setPendente(null)} largura={380}>
          <div style={{ textAlign: "center" }}>
            <div style={{ display: "flex", justifyContent: "center", marginBottom: 14 }}>
              {idiomaPendente && <idiomaPendente.Bandeira />}
            </div>
            <div style={{ fontSize: 17, fontWeight: 800, marginBottom: 8 }}>
              {t("common.confirmar_troca_idioma_titulo")}
            </div>
            <div style={{ color: "var(--text2)", fontSize: 13.5, lineHeight: 1.6, marginBottom: 24 }}>
              {t("common.confirmar_troca_idioma_texto", {
                idioma: idiomaPendente ? t(idiomaPendente.chaveNome) : "",
              })}
            </div>
            <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
              <button
                onClick={() => setPendente(null)}
                style={{
                  background: "var(--bg3)",
                  border: "1px solid var(--border)",
                  borderRadius: 8,
                  color: "var(--text2)",
                  cursor: "pointer",
                  fontSize: 13,
                  fontWeight: 600,
                  padding: "10px 20px",
                }}
              >
                {t("common.cancelar")}
              </button>
              <button
                onClick={confirmarTroca}
                style={{
                  background: "#3b82f6",
                  border: "none",
                  borderRadius: 8,
                  color: "#fff",
                  cursor: "pointer",
                  fontSize: 13,
                  fontWeight: 700,
                  padding: "10px 20px",
                }}
              >
                {t("common.confirmar")}
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
}
